export enum UserRole {
    SuperUser = "User.Super",
    Contractor = "User.Contractor",
    NotAuthorized = "NotAuthorized"
}
